import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import imagen1 from '../assets/images/HeaderFooter/inverdronjgwiconfooter.webp'

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-black to-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <div className="mb-6">
              <img
                src={imagen1}
                alt="Inverdron JGW"
                className="h-14 w-auto object-contain"
              />
            </div>

            <p className="text-gray-300 mb-4">
              Líderes en comercialización y distribución de elementos para trabajos con tensión y EPPs especializados.
            </p>
            <div className="text-gray-400 text-sm">
              <p>Certificaciones nacionales</p>
              <p>Más de 8 años de experiencia</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h4 className="text-xl font-bold mb-4">Productos</h4>
            <ul className="space-y-0.5 text-gray-300">
              <li><a> Elementos de Protección Personal</a></li>
              <li><a> Elementos para TCT y Redes</a></li>
              <li><a> Elementos para Izaje y Retención</a></li>
              <li><a> Equipos de Medición y Detección</a></li>
              <li><a> Equipos de Puesta a Tierra</a></li>
              <li><a> Equipos para Trabajo en Alturas</a></li>
              <li><a> Herramienta Aislada</a></li>
              <li><a> Herramienta Manual</a></li>
              <li><a>Herramienta Motorizada</a></li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h4 className="text-xl font-bold mb-4">Servicios</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a> Mantenimiento</a></li>
              <li><a> Laboratorio</a></li>
              <li><a> Asesoramiento Técnico</a></li>
              <li><a> Capacitación</a></li>
              <li><a> Soporte 24/7</a></li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <h4 className="text-xl font-bold mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="text-sm">Calle 75A #61 - San Fernando<br/>Bogotá, Colombia</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-yellow-400" />
                <span className="text-sm">+57 (300) 576 1607<br />+57 (317) 429 5659<br /></span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400" />
                <span className="text-sm">info@inverdronjgw.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-yellow-400" />
                <span className="text-sm">Lun-Vie: 7:30 AM - 5:00 PM<br />Sab: 8:30 AM - 12:00 PM</span>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <p>&copy; {currentYear} Inverdron JGW - Developed By: Jhon Alexander Castillo © 2026. Todos los derechos reservados.</p>
          <p className="text-sm mt-2">
            Cuidamos a quienes dan energía al mundo | Equipos de protección personal Certificacos | Productos especializados para trabajo eléctrico
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

export default Footer;